<div class="u-flex">
  <form-control
    [control]="tempGroup.get(termsAndConditions.prop)"
    [config]="termsAndConditions"
    class="TermsAndConditions__FormControl"
  >
  </form-control>
</div>
